const CryptoJS = require("crypto-js");

const ENCRYPTION_KEY = 'asgsfdhbfdbgh.rtgadfbadgf1246tygfbnrj67876rew@df';

const setSessionData = (data, key) => {
    try {
        const x = typeof data === "string" ? data : JSON.stringify(data);
        var encryptData = CryptoJS.AES.encrypt(x, ENCRYPTION_KEY).toString();
        sessionStorage.setItem(key, encryptData);
        return true;
    } catch (error) {
        console.error('Error setting session data:', error);
        return false;
    }
};

const getSessionData = (key) => {
    try {
        const encryptedData = sessionStorage.getItem(key);
        if (encryptedData) {
            var bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
            var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            return decryptedData;
        }
        return encryptedData;
    } catch (error) {
        console.error('Error getting session data:', error);
        return null;
    }
};

const updateManifestFile = (id, token) => {
    if (!id || !token) return;

    try {
        // Clean up any existing manifest links first
        const existingLinks = document.querySelectorAll('link[rel="manifest"]');
        existingLinks.forEach(link => {
            if (link.href.startsWith('blob:')) {
                URL.revokeObjectURL(link.href);
            }
            link.remove();
        });

        var myDynamicManifest = {
            "short_name": "ACT-ARS",
            "name": "ACT-ARS",
            "icons": [
                {
                    "src": "all_city_fukkll_logo.png",
                    "type": "image/png",
                    "sizes": "192x192",
                    "purpose": "any maskable"
                },
                {
                    "src": "all_city_fukkll_logo.png",
                    "type": "image/png",
                    "sizes": "512x512",
                    "purpose": "any maskable"
                }
            ],
            "start_url": `https://devars.allcityapp.com/validateAcct/${id}/${token}`,
            "display": "standalone",
            "theme_color": "#F4BD42",
            "background_color": "#2B2929",
            "scope": "/",
            "orientation": "any"
        };

        const stringManifest = JSON.stringify(myDynamicManifest);

        // Create and append the new manifest link
        const link = document.createElement('link');
        link.rel = "manifest";
        
        // Use base64 encoding for better compatibility
        const base64Manifest = btoa(stringManifest);
        link.href = `data:application/json;base64,${base64Manifest}`;
        
        document.head.appendChild(link);

        // Update placeholder if it exists
        const placeholder = document.querySelector('#my-manifest-placeholder');
        if (placeholder) {
            placeholder.href = link.href;
        }

        return true;
    } catch (error) {
        console.error('Error updating manifest:', error);
        return false;
    }
};

const getOS = () => {
    try {
        const userAgent = window.navigator.userAgent;
        const platform = window.navigator?.userAgentData?.platform || window.navigator.platform;
        
        const platforms = {
            'Mac OS': ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            'iOS': ['iPhone', 'iPad', 'iPod'],
            'Windows': ['Win32', 'Win64', 'Windows', 'WinCE'],
            'Android': [/Android/],
            'Linux': [/Linux/]
        };

        for (const [os, identifiers] of Object.entries(platforms)) {
            for (const identifier of identifiers) {
                if (typeof identifier === 'string') {
                    if (platform === identifier) return os;
                } else if (identifier.test(userAgent)) {
                    return os;
                }
            }
        }

        return 'Unknown OS';
    } catch (error) {
        console.error('Error detecting OS:', error);
        return 'Unknown OS';
    }
};

const beep = (vol, freq, duration) => {
    try {
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();

        oscillator.connect(gainNode);
        oscillator.frequency.value = freq;
        oscillator.type = "square";
        
        gainNode.connect(audioContext.destination);
        gainNode.gain.value = vol * 0.01;
        
        const startTime = audioContext.currentTime;
        const stopTime = startTime + duration * 0.001;
        
        oscillator.start(startTime);
        oscillator.stop(stopTime);

        // Clean up
        setTimeout(() => {
            audioContext.close();
        }, duration + 100);
    } catch (error) {
        console.error('Error playing beep:', error);
    }
};

// Add new function for link validation
// const validateLink = async (accountId, uniqueCode, maxRetries = 1) => {
//     let retryCount = 0;

//     const attemptValidation = async () => {
//         try {
//             const response = await fetch(
//                 `https://devars.allcityapp.com/actadmin/account/validateAccLink/${accountId}/${uniqueCode}`,
//                 {
//                     method: 'GET',
//                     headers: {
//                         'Cache-Control': 'no-cache, no-store, must-revalidate',
//                         'Pragma': 'no-cache'
//                     }
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error('Link validation failed');
//             }

//             return await response.json();
//         } catch (error) {
//             if (retryCount < maxRetries) {
//                 retryCount++;
//                 await new Promise(resolve => setTimeout(resolve, 1000));
//                 return attemptValidation();
//             }
//             throw error;
//         }
//     };

//     return attemptValidation();
// };

export {
    setSessionData,
    getSessionData,
    updateManifestFile,
    getOS,
    beep
};